var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLawyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 16H2.00002C1.46958 16 0.960867 16.2107 0.585791 16.5858C0.210715 16.9609 0 17.4696 0 18C0 18.5305 0.210715 19.0392 0.585791 19.4142C0.960867 19.7893 1.46958 20 2.00002 20H18.0001C18.5306 20 19.0393 19.7893 19.4144 19.4142C19.7894 19.0392 20.0002 18.5305 20.0002 18C20.0002 17.4696 19.7894 16.9609 19.4144 16.5858C19.0393 16.2107 18.5306 16 18.0001 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00003 8.6665H2V14.6666H6.00003V8.6665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5575 3.37187L10.2241 0.0385137C10.0792 -0.0128379 9.92099 -0.0128379 9.77608 0.0385137L0.44267 3.37187C0.31311 3.41809 0.201018 3.50326 0.121766 3.61569C0.0425137 3.72812 -1.89781e-05 3.86232 6.35253e-09 3.99988V6.66656C6.35253e-09 6.84338 0.0702384 7.01295 0.195264 7.13797C0.320289 7.263 0.489859 7.33324 0.666672 7.33324H19.3335C19.5103 7.33324 19.6799 7.263 19.8049 7.13797C19.9299 7.01295 20.0002 6.84338 20.0002 6.66656V3.99988C20.0002 3.86232 19.9576 3.72812 19.8784 3.61569C19.7991 3.50326 19.687 3.41809 19.5575 3.37187Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.6665H8.00012V14.6666H12.0002V8.6665Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 8.6665H14.0001V14.6666H18.0002V8.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLawyer);
export default __webpack_public_path__ + "static/media/white_lawyer.399be1e73345462e6a561585bbaf4d9d.svg";
export { ForwardRef as ReactComponent };